class ConsoleLocalStorageClass {
  setAccessToken(token) {
    localStorage.setItem("access_token", token);
  }
  getAccessToken() {
    return localStorage.getItem("access_token");
  }

  setRefreshToken(token) {
    localStorage.setItem("refresh_token", token);
  }
  getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  setRememberMe(flag) {
    localStorage.setItem("remember_me", flag);
  }
  getRememberMe() {
    return localStorage.getItem("remember_me");
  }

  setOrganization(user) {
    localStorage.setItem("organization", JSON.stringify(user));
  }
  getOrganization() {
    return JSON.parse(localStorage.getItem("organization"));
  }

  setFTU(status){
    localStorage.setItem("ftu", JSON.stringify(status));
  }

  getFTU(){
    return JSON.parse(localStorage.getItem("ftu"));
  }

  //discord
  setDiscordInviteUrl(url){
    localStorage.setItem("discord_invite_url", JSON.stringify(url));
  }
  getDiscordInviteUrl(){
    return JSON.parse(localStorage.getItem("discord_invite_url"));
  }

  setDiscordAccessUrl(url){
    localStorage.setItem("discord_access_url", JSON.stringify(url));
  }
  getDiscordAccessUrl(){
    return JSON.parse(localStorage.getItem("discord_access_url"));
  }

  setDiscordJoined(flag){
    localStorage.setItem("discord_joined", flag);
  }
  getDiscordJoined(){
    return JSON.parse(localStorage.getItem("discord_joined"));
  }

  setDiscordVerified(flag){
    localStorage.setItem("discord_verified", flag);
  }
  getDiscordVerified(){
    return JSON.parse(localStorage.getItem("discord_verified"));
  }

  clearStorageExceptFTU(){
    localStorage.removeItem("access_token");
    localStorage.removeItem("organization");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("remember_me");
    localStorage.removeItem("user");
    localStorage.removeItem("discord_verified");
    localStorage.removeItem("discord_joined");
    localStorage.removeItem("discord_access_url");
    localStorage.removeItem("discord_invite_url");
    
  }

}
const ConsoleLocalStorage = new ConsoleLocalStorageClass();
export default ConsoleLocalStorage;
